import React, { createContext, useContext, useState } from "react"

export const Context = createContext()

export const useModalContext = () => {
  const context = useContext(Context);
  return context;
}

export const ModalContext = ({ children }) => {
	const [modalData, openModal] = useState({
		isOpen: false,
		variant: null,
		link: null,
		vimeoLink: null,
		copy: null,
		buttons: null
	});

	return (
		<Context.Provider value={{
			data: modalData,
			open: openModal
		}}>
			{children}
		</Context.Provider>
	)
}